"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRESENTER_BANNER_ANIMATION = exports.PLACEHOLDER_SOURCE = exports.MAX_CAMERA_COUNT = exports.HARD_CUT_ANIMATION = exports.DEFAULT_ANIMATION = exports.COMMON_SOURCE_STYLES = exports.COMMON_SCENE_STYLES = exports.COMMON_CAMERA_STYLES = void 0;
Object.defineProperty(exports, "SCENE_ASPECT_RATIO", {
  enumerable: true,
  get: function get() {
    return _SceneLayouts.SCENE_ASPECT_RATIO;
  }
});
exports.SCENE_HEIGHT = void 0;
Object.defineProperty(exports, "SCENE_WIDTH", {
  enumerable: true,
  get: function get() {
    return _SceneLayouts.SCENE_WIDTH;
  }
});
exports.addAudioSourceToScene = addAudioSourceToScene;
exports.buildPresenterBannerLayerSource = buildPresenterBannerLayerSource;
exports.extraPresenterBannerStyles = exports.disableAnimations = void 0;
exports.getAudioSourceIndex = getAudioSourceIndex;
exports.getCameraSources = getCameraSources;
exports.getNonAudioPresenterSources = getNonAudioPresenterSources;
exports.getPresenterBannerPosition = getPresenterBannerPosition;
exports.getPresenterBannerTemplate = getPresenterBannerTemplate;
exports.getSceneLayerSources = getSceneLayerSources;
exports.gridConfigMap = void 0;
exports.isBackground = isBackground;
exports.isIterable = isIterable;
exports.isOverlay = isOverlay;
exports.isPresenterBannerLayerSource = isPresenterBannerLayerSource;
exports.moveFeaturedPresenterToFront = moveFeaturedPresenterToFront;
exports.prepareSceneForUpdate = prepareSceneForUpdate;
exports.sanitizeScene = sanitizeScene;
exports.sceneLayersHaveDescription = void 0;
exports.scenePreviewAnimationHelper = scenePreviewAnimationHelper;
exports.updateBackgroundSignedUrl = updateBackgroundSignedUrl;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _underscore = require("underscore");
var _SceneLayouts = require("../../constants/SceneLayouts");
var _SourceItems = require("../../constants/SourceItems");
var _Banners = require("../../constants/Banners");
var _LayerPositions = require("../../constants/LayerPositions");
var _sceneBuilder = require("../../scene/sceneBuilder/sceneBuilder");
var _broadcastSourceHelper = require("../broadcastSourceHelper/broadcastSourceHelper");
var _Placeholders = require("@studio/constants/Placeholders");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var DEFAULT_ANIMATION = exports.DEFAULT_ANIMATION = {
  exit: {
    opacity: 0
  },
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1
  },
  transition: {
    duration: 0.4
  }
};

/**
 * Cuts in source into the program because of a transition duration of 0
 */
var HARD_CUT_ANIMATION = exports.HARD_CUT_ANIMATION = {
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1
  },
  exit: {
    opacity: 0
  },
  transition: {
    duration: 0
  }
};
var SCENE_HEIGHT = exports.SCENE_HEIGHT = _SceneLayouts.SCENE_WIDTH / _SceneLayouts.SCENE_ASPECT_RATIO;
var COMMON_SCENE_STYLES = exports.COMMON_SCENE_STYLES = {
  backgroundColor: '#000000'
};
var COMMON_SOURCE_STYLES = exports.COMMON_SOURCE_STYLES = {
  // To debug, or when testing with sceneBuilder.story.js, uncomment this line
  margin: 0,
  borderRadius: 4
};
var COMMON_CAMERA_STYLES = exports.COMMON_CAMERA_STYLES = {
  styles: {},
  mediaStyles: {
    width: 'unset',
    maxWidth: '100%',
    display: 'block',
    margin: '0 auto',
    objectFit: 'cover'
  }
};
var PLACEHOLDER_SOURCE = exports.PLACEHOLDER_SOURCE = {
  type: _SourceItems.IMAGE_FILE,
  _id: 'place_holder',
  title: 'Image file',
  value: (0, _Placeholders.getPlaceholderUrl)('1x1')
};

/**
 * @param {[]} sources
 */
function getCameraSources(sources) {
  return sources.filter(function (source) {
    return (source === null || source === void 0 ? void 0 : source.type) === _SourceItems.CAMERA_PRESENTER;
  });
}

// Update this constant whenever you increase/decrease possible camera count
var MAX_CAMERA_COUNT = exports.MAX_CAMERA_COUNT = 10;

/**
 * A lookup for grid arrangement on the grid based on the number of camera sources.
 * Do update MAX_CAMERA_COUNT constant whenever your increase/decrease camera count.
 */
var gridConfigMap = exports.gridConfigMap = (0, _defineProperty2["default"])({
  2: {
    row1Count: 2,
    row2Count: 0
  },
  3: {
    row1Count: 2,
    row2Count: 1
  },
  4: {
    row1Count: 2,
    row2Count: 2
  },
  5: {
    row1Count: 3,
    row2Count: 2
  },
  6: {
    row1Count: 3,
    row2Count: 3
  },
  7: {
    row1Count: 4,
    row2Count: 3
  },
  8: {
    row1Count: 4,
    row2Count: 4
  },
  9: {
    row1Count: 5,
    row2Count: 4
  }
}, MAX_CAMERA_COUNT, {
  row1Count: 5,
  row2Count: 5
});

/**
 * Check if other layer sources in the scene have description.
 * If any other layer source has a description, then we return true,
 * so that this particular layer source can have it's banner height (name card) to be the same as
 * other layer sources that have description/name card
 */
var sceneLayersHaveDescription = exports.sceneLayersHaveDescription = function sceneLayersHaveDescription() {
  var description = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var sceneLayers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var currentLayerSource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return description.length > 0 || sceneLayers.some(function (sceneLayer) {
    var _ref = sceneLayer.source || {},
      type = _ref.type,
      description = _ref.description,
      _id = _ref._id;
    return currentLayerSource._id !== _id && type === _SourceItems.CAMERA_PRESENTER && (description === null || description === void 0 ? void 0 : description.length) > 0;
  });
};

/**
 * Filters out audio presenter sources
 * @param {Array} sources all the sources in broadcast
 * @return {Array} an array of broadcast sources excluding audio presenters.
 */
function getNonAudioPresenterSources(sources) {
  return sources.filter(function (source) {
    return source && source.type !== _SourceItems.AUDIO_PRESENTER;
  });
}

/**
 * If featured presenter is set on the list of sources ensure that it comes first
 * so that it is rendered first.
 * @param sources
 */
function moveFeaturedPresenterToFront(sources) {
  // Move featured presenter to front of array if it exists
  var featuredPresenter = sources.find(function (source) {
    return source.type === _SourceItems.CAMERA_PRESENTER && source.featured;
  });
  if (sources.indexOf(featuredPresenter) > 0) {
    sources.splice(sources.indexOf(featuredPresenter), 1);
    sources.unshift(featuredPresenter);
  }
  return sources;
}

/**
 * Returns the location of audio source if it exists
 * @param {[]} sources
 */
function getAudioSourceIndex(sources) {
  var audioSource = sources.find(function (source) {
    return source.type === _SourceItems.AUDIO_FILE;
  });
  return sources.indexOf(audioSource);
}

/**
 * Adds audio source to the existing scene
 * no styles applied since audio sources are hidden
 * @param {{}} source
 */
function addAudioSourceToScene(source) {
  return {
    _id: 'audioSource1',
    source: source,
    layer: {
      animation: {
        animate: {
          opacity: 0
        },
        exit: {
          opacity: 0
        },
        transition: {
          duration: 0
        }
      },
      style: {
        width: 0,
        height: 0,
        padding: 0,
        mediaStyle: {
          width: 0,
          height: 0
        },
        position: 'absolute'
      }
    }
  };
}
var PRESENTER_BANNER_ANIMATION = exports.PRESENTER_BANNER_ANIMATION = {
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1
  },
  exit: {
    opacity: 0
  },
  transition: {
    duration: 1
  }
};

/**
   @description Returns banner position in tile depending with selected scene layout.
   @param {{
     top : number
     left : number
     width : number
     height : number
   }} tileStyles
   */
function getPresenterBannerPosition(tileStyles) {
  var paddingLeft = 1;
  var paddingBottom = 40;
  var left = tileStyles.left,
    top = tileStyles.top,
    height = tileStyles.height,
    width = tileStyles.width;
  var calculatedTop = top + height - paddingBottom;
  return {
    maxWidth: width + 2,
    top: calculatedTop + 1,
    position: 'absolute',
    left: left - paddingLeft
  };
}

/**
 * @description Returns presenter banner as a layer source with all presenter details, styles and animations.
 * @param {{}} presenterBanner
 * @param {{}} sourceLayer
 * @param {string} sceneId
 * @param {[]} sceneLayers
 */
function buildPresenterBannerLayerSource(presenterBanner, sourceLayer, sceneId, sceneLayers) {
  var layer = sourceLayer.layer,
    source = sourceLayer.source;
  var title = source.title,
    description = source.description,
    sourceId = source._id;
  var _ref2 = layer || {},
    style = _ref2.style;
  var layerCount = sceneLayers === null || sceneLayers === void 0 ? void 0 : sceneLayers.length;
  var hasDescription = sceneLayersHaveDescription(description, sceneLayers, source);
  if (layerCount > _Banners.HIDE_DESCRIPTION_ON_COUNT_EXCEEDING) {
    hasDescription = false;
  }
  var bannerStyles = style.bannerStyles,
    bannerAnimation = style.bannerAnimation,
    width = style.width;
  var markup = presenterBanner.source.value.markup;
  var _formatBannerMarkup = (0, _broadcastSourceHelper.formatBannerMarkup)(title, hasDescription ? description : '', markup, presenterBanner.source.value.templateVars),
    bannerMarkup = _formatBannerMarkup.bannerMarkup,
    titleStyle = _formatBannerMarkup.titleStyle,
    subTitleStyle = _formatBannerMarkup.subTitleStyle;
  var bannerSource = presenterBanner.source,
    bannerLayer = presenterBanner.layer;
  var bannerSourceValue = bannerSource.value,
    bannerSourceId = bannerSource._id;
  var templateVars = bannerSourceValue.templateVars;

  /**
   * Framer motion library needs this to be unique for animations to work
   * We are re-using same banner template to generate presenter banners.
   */
  var newBannerSourceId = "".concat(bannerSourceId, "_").concat(sourceId);

  // Override default styles
  var titleHeight = 50;
  var paddingLeft = 6;
  var paddingRight = 6;
  var titleHeightNumb = 50;
  var heightDescription = 40;
  var maxWidth = 0;
  var bannerHeight = hasDescription ? heightDescription + titleHeightNumb : titleHeight;
  var _titleStyle$paddingTo = titleStyle.paddingTop,
    titlePaddingTop = _titleStyle$paddingTo === void 0 ? 0 : _titleStyle$paddingTo;
  // Scenes taking full height
  var fullHeightScenes = [_SceneLayouts.SIDE_BY_SIDE.id, _SceneLayouts.SINGLE.id];
  var bannerTop = bannerStyles.top;
  // Don't add bottom padding to scenes taking full height
  if (hasDescription && !fullHeightScenes.includes(sceneId)) {
    bannerTop = bannerStyles.top - 30;
  }
  maxWidth = width ? width - paddingRight : 0;
  /*
   * Calculate banner top position,
   * for presenter banners according to presenter description
   */
  var bannerAnimationTop = bannerAnimation.animate.top;
  if (!hasDescription) {
    bannerAnimationTop = bannerAnimationTop + 30;
  } else {
    bannerAnimationTop = bannerAnimationTop - 10;
  }

  // Default banner template fonts
  var titleFontSize = 30;
  var subTitleFontSize = 26;
  var layoutsToScale = [_SceneLayouts.FEATURED_MEDIA.id, _SceneLayouts.FEATURED_SCREEN.id];
  if (layoutsToScale.includes(sceneId)) {
    var _sceneLayers$filter;
    var cameraSources = sceneLayers === null || sceneLayers === void 0 || (_sceneLayers$filter = sceneLayers.filter(function (layer) {
      var _layer$source;
      return [_SourceItems.CAMERA_PRESENTER].includes(layer === null || layer === void 0 || (_layer$source = layer.source) === null || _layer$source === void 0 ? void 0 : _layer$source.type);
    })) === null || _sceneLayers$filter === void 0 ? void 0 : _sceneLayers$filter.length;
    if (cameraSources >= _Banners.SCALE_PRESENTER_BANNERS_ON_CAMERAS_EXCEEDING) {
      var columns = cameraSources / 2;
      var titleLength = title === null || title === void 0 ? void 0 : title.length;
      var newBannerHeight = bannerHeight / cameraSources + columns;

      /**
           If title has 20 or more characters, we set a fixed font size,
           this will ensure both title and sub title are truncated when length exceeds.
         */
      if (titleLength >= _Banners.MAX_PRESENTER_BANNERS_CHARACTERS) {
        titleFontSize = 20;
        subTitleFontSize = 20;
      } else {
        // Scale down fonts.
        titleFontSize = Math.floor(titleFontSize - cameraSources);
        subTitleFontSize = Math.floor(subTitleFontSize - cameraSources);
      }

      // Remove padding to have more space for title
      titlePaddingTop = 0;

      // Scale down heights.
      titleHeight = Math.floor(titleHeight - columns);
      bannerHeight = Math.floor(bannerHeight - newBannerHeight);

      // Increase animation top, determined by height of presenter tile in program.
      bannerAnimationTop = Math.floor(bannerAnimationTop + newBannerHeight);
    }
  }
  var banner = _objectSpread(_objectSpread({}, presenterBanner), {}, {
    layer: _objectSpread(_objectSpread({}, bannerLayer), {}, {
      animation: _objectSpread(_objectSpread({}, bannerAnimation), {}, {
        animate: _objectSpread(_objectSpread({}, bannerAnimation.animate), {}, {
          top: bannerAnimationTop
        })
      }),
      style: _objectSpread(_objectSpread(_objectSpread({}, bannerLayer.style), bannerStyles), {}, {
        width: '100%',
        top: bannerTop,
        height: "".concat(bannerHeight, "px !important"),
        bannerStyle: {
          height: "".concat(bannerHeight, "px !important")
        },
        titleStyle: _objectSpread(_objectSpread({}, titleStyle), {}, {
          maxWidth: maxWidth,
          alignItems: 'flex-start',
          paddingTop: titlePaddingTop,
          margin: '4px 0px !important',
          overflow: 'hidden !important',
          whiteSpace: 'nowrap !important',
          display: 'inline-block !important',
          textOverflow: 'ellipsis !important',
          height: "".concat(titleHeight, "px !important"),
          fontSize: "".concat(titleFontSize, "px !important"),
          paddingLeft: "".concat(paddingLeft, "px !important"),
          lineHeight: "".concat(titleFontSize, "px !important"),
          paddingRight: "".concat(paddingRight, "px !important")
        }),
        subTitleStyle: _objectSpread(_objectSpread({}, subTitleStyle), {}, {
          maxWidth: maxWidth,
          alignItems: 'flex-start',
          margin: '4px 0px !important',
          overflow: 'hidden !important',
          whiteSpace: 'nowrap !important',
          display: 'inline-block !important',
          textOverflow: 'ellipsis !important',
          height: "".concat(titleHeight, "px !important"),
          paddingLeft: "".concat(paddingLeft, "px !important"),
          fontSize: "".concat(subTitleFontSize, "px !important"),
          paddingRight: "".concat(paddingRight, "px !important"),
          lineHeight: "".concat(subTitleFontSize, "px !important")
        }),
        animation: bannerAnimation
      })
    }),
    source: _objectSpread(_objectSpread({}, bannerSource), {}, {
      _id: newBannerSourceId,
      value: _objectSpread(_objectSpread({}, bannerSourceValue), {}, {
        markup: bannerMarkup,
        templateVars: _objectSpread(_objectSpread({}, templateVars), {}, {
          LINE_1: title,
          LINE_2: description || '',
          LINE_3: sourceId
        })
      })
    })
  });
  return banner;
}

/**
 * Returns presenter banner template
 * @param {[]} banners
 * @returns {{} | undefined}
 */
function getPresenterBannerTemplate(banners) {
  var banner = banners.find(function (_ref3) {
    var _source$value;
    var source = _ref3.source;
    return (source === null || source === void 0 || (_source$value = source.value) === null || _source$value === void 0 ? void 0 : _source$value.templateType) === _Banners.PRESENTER_BANNER;
  });
  return banner;
}
var extraPresenterBannerStyles = exports.extraPresenterBannerStyles = {
  overflow: 'hidden'
};

/**
 * @description Whether layer source value is presenter banner.
 * @param {{}} value
 */
function isPresenterBannerLayerSource(value) {
  return (0, _typeof2["default"])(value) === 'object' && (value === null || value === void 0 ? void 0 : value.templateType) === _Banners.PRESENTER_BANNER;
}

/**
 * @description This passes scene through the scene builder to rebuild a scene
 * object ready for preview in program.
 * @param {Object} scene
 * @returns Object
 */
function prepareSceneForUpdate(scene) {
  var filterDuplicateLayers = {};
  scene.layers.forEach(function (layer) {
    if (!filterDuplicateLayers[layer.source._id]) {
      filterDuplicateLayers[layer.source._id] = layer;
    }
  });
  var updatedLayers = Object.values(filterDuplicateLayers);
  var sceneLayers = ['SCENE_LAYER'].concat((0, _toConsumableArray2["default"])(getSceneLayerSources(updatedLayers)));
  var sources = updatedLayers.map(function (layer) {
    return layer.source;
  });
  var sceneLayout = (0, _broadcastSourceHelper.getSceneLayout)(scene);
  var rebuiltScene = (0, _sceneBuilder.sceneBuilder)(sceneLayout, sources, sceneLayers);
  return _objectSpread(_objectSpread({}, scene), {}, {
    style: _objectSpread(_objectSpread({}, rebuiltScene.style), scene.style),
    layers: rebuiltScene.layers
  });
}

/**
 * @param {Array} layers
 */
function getSceneLayerSources(layers) {
  return layers.filter(function (_ref4) {
    var layer = _ref4.layer;
    return (layer === null || layer === void 0 ? void 0 : layer.isContent) === false;
  });
}

/**
 * Checks is a variable is iterable
 */
function isIterable(value) {
  return Symbol.iterator in Object(value);
}

/**
   @description This will updated scenes with background with the most recent background value
   @param {Array} scenes the current scenes array
   @param {Array} backgrounds the backgrounds whose source value has the most resent signed url
   */
function updateBackgroundSignedUrl(scenes, backgrounds) {
  /**
   * This object is created to reduce the number of find
   * that is required as it background id to url
   */
  var scenesBackgroundCache = {};
  return scenes.map(function (scene) {
    var _scene$style, _scene$style2, _scene$style3, _scene$style5, _scene$style6;
    var sceneHasBackground = (scene === null || scene === void 0 || (_scene$style = scene.style) === null || _scene$style === void 0 ? void 0 : _scene$style.backgroundImage) && (scene === null || scene === void 0 || (_scene$style2 = scene.style) === null || _scene$style2 === void 0 ? void 0 : _scene$style2.backgroundId);
    if (!sceneHasBackground) return scene;
    if (!scenesBackgroundCache[scene === null || scene === void 0 || (_scene$style3 = scene.style) === null || _scene$style3 === void 0 ? void 0 : _scene$style3.backgroundId]) {
      var _background$source;
      var background = backgrounds.find(function (bg) {
        var _scene$style4;
        return bg._id === (scene === null || scene === void 0 || (_scene$style4 = scene.style) === null || _scene$style4 === void 0 ? void 0 : _scene$style4.backgroundId);
      });
      if (!background) {
        scene.style = {
          backgroundColor: '#000000'
        };
        return scene;
      }
      scenesBackgroundCache[background._id] = background === null || background === void 0 || (_background$source = background.source) === null || _background$source === void 0 || (_background$source = _background$source.value) === null || _background$source === void 0 ? void 0 : _background$source.url;
    }
    scene.style = _objectSpread(_objectSpread({}, scene.style), {}, {
      backgroundId: scene === null || scene === void 0 || (_scene$style5 = scene.style) === null || _scene$style5 === void 0 ? void 0 : _scene$style5.backgroundId,
      backgroundImage: "url(".concat(scenesBackgroundCache[scene === null || scene === void 0 || (_scene$style6 = scene.style) === null || _scene$style6 === void 0 ? void 0 : _scene$style6.backgroundId], ")")
    });
    return scene;
  });
}

/**
 * returns the scene without the layer animations.
 * @param {{}} scene
 */
function scenePreviewAnimationHelper(scene) {
  var _scene$layers;
  var sceneLayers = (_scene$layers = scene.layers) === null || _scene$layers === void 0 ? void 0 : _scene$layers.map(function (layerSource) {
    if ([_SourceItems.IMAGE_FILE, _SourceItems.PDF_FILE, _SourceItems.VIDEO_FILE, _SourceItems.CAMERA_PRESENTER].includes(layerSource.source.type)) {
      return {
        source: layerSource.source,
        layer: _objectSpread(_objectSpread({}, layerSource.layer), {}, {
          animation: _objectSpread({}, HARD_CUT_ANIMATION)
        })
      };
    }
    return layerSource;
  });
  return _objectSpread(_objectSpread({}, scene), {}, {
    layers: sceneLayers
  });
}

/**
 * Removes any "extra" source props that are part of the local state so as to avoid problems w/ api validation when trying to send scene updates
 * @param {{}} scene
 */
function sanitizeScene(scene) {
  var _sanitized$layers;
  var sanitized = _objectSpread({}, scene);
  sanitized.layers = (_sanitized$layers = sanitized.layers) === null || _sanitized$layers === void 0 ? void 0 : _sanitized$layers.map(function (ls) {
    var mappedLayerSource = _objectSpread({}, ls);
    if (ls && ls !== null && ls !== void 0 && ls.source) {
      mappedLayerSource.source = (0, _underscore.pick)(ls.source, '_id', 'type', 'title', 'value', 'order', 'hidden', 'thumbnail', 'description', 'photo');
    }

    // WAF won't allow this, see https://github.com/shoflo/issues/issues/9776
    if (mappedLayerSource.source.value && mappedLayerSource.source.value.markup) {
      delete mappedLayerSource.source.value.markup;
    }
    return mappedLayerSource;
  });
  return sanitized;
}

/**
 * This returns a scene with disabled animation
 *
 * @param {Object} scene program or scene layers
 * @returns {Object} the updated scene
 */
var disableAnimations = exports.disableAnimations = function disableAnimations(scene) {
  if (scene && scene.layers && scene.layers.length) {
    scene.layers = scene.layers.map(function (layerSource) {
      var _layerSource$layer;
      if (layerSource !== null && layerSource !== void 0 && layerSource.layer && (_layerSource$layer = layerSource.layer) !== null && _layerSource$layer !== void 0 && _layerSource$layer.animation) {
        return _objectSpread(_objectSpread({}, layerSource), {}, {
          layer: _objectSpread(_objectSpread({}, layerSource.layer), {}, {
            animation: _objectSpread(_objectSpread({}, layerSource.layer.animation), {}, {
              transition: {
                duration: 0
              }
            })
          })
        });
      }
      return layerSource;
    });
  }
  return scene;
};

/**
 * @param {{}} style
 */
function isOverlay(style) {
  return (0, _underscore.isEqual)(style, _LayerPositions.OverlayStyles[_LayerPositions.UPPER_LEFT]) || (0, _underscore.isEqual)(style, _LayerPositions.OverlayStyles[_LayerPositions.UPPER_RIGHT]) || (0, _underscore.isEqual)(style, _LayerPositions.OverlayStyles[_LayerPositions.LOWER_LEFT]) || (0, _underscore.isEqual)(style, _LayerPositions.OverlayStyles[_LayerPositions.LOWER_RIGHT]) || (0, _underscore.isEqual)(style, _LayerPositions.OverlayStyles[_LayerPositions.FULL_SCREEN]);
}

/**
 * @param {{}} style
 */
function isBackground(style) {
  return (0, _underscore.isEqual)(style, _LayerPositions.BackgroundStyles[_LayerPositions.FIT_FRAME]) || (0, _underscore.isEqual)(style, _LayerPositions.BackgroundStyles[_LayerPositions.FILL_FRAME]);
}